import { type FC } from 'react'
import { Spinner } from '../../../../components/Spinner/Spinner'
import { useSchedulingTemplatesEnabled } from '../../../Scheduling/shared/useSchedulingTemplatesEnabled'
import { EmailTemplatesSetupSection } from './EmailTemplatesSetup/EmailTemplatesSetupSection'
import { LegacyMessageTemplatesSection } from './LegacyMessageTemplatesSection'

interface MessageTemplatesSectionProps {
  onShowReminders?: () => void
}

export const MessageTemplatesSection: FC<MessageTemplatesSectionProps> = ({ onShowReminders }) => {
  const { isEnabled, isLoading } = useSchedulingTemplatesEnabled()

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center py-5'>
        <Spinner />
      </div>
    )
  }

  return isEnabled ? <EmailTemplatesSetupSection onShowReminders={onShowReminders} /> : <LegacyMessageTemplatesSection />
}
